import { render, staticRenderFns } from "./noticeManage.vue?vue&type=template&id=b6186e28&scoped=true"
import script from "./noticeManage.vue?vue&type=script&lang=js"
export * from "./noticeManage.vue?vue&type=script&lang=js"
import style0 from "./noticeManage.vue?vue&type=style&index=0&id=b6186e28&prod&lang=scss&scoped=true"
import style1 from "./noticeManage.vue?vue&type=style&index=1&id=b6186e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6186e28",
  null
  
)

export default component.exports